import { IconButton } from '@mui/material';
import styled, { css } from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: row;
    background: #ffffff;
    border: 1px solid #c4c4c4;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    padding: 0.5rem;
    width: 330px;
    min-height: 8rem;
    cursor: pointer;
    position: relative;

    aside {
        width: 126px;
        margin-right: 0.8rem;
        height: 100%;
        position: relative;

        > img {
            position: absolute;
            width: 100%;
            height: 100%;
            border-radius: 8px;
            background-position: center;
            background-size: cover;
            object-fit: cover;
            background-color: #eee;
        }
    }

    > main {
        width: 156px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        > header {
            display: flex;
            flex-direction: row;

            > h3 {
                font-size: 0.9rem;
            }
            margin-bottom: 0.5rem;
            ${({ completed }) =>
                completed &&
                css`
                    padding-right: 0.8rem;
                `}
        }

        > footer {
            > * {
                margin-bottom: 0.5rem;
            }

            button {
                float: right;
            }

            &:last-child {
                margin-bottom: 0;
            }
        }
    }
`;

export const CloseContainer = styled(IconButton)`
    position: absolute;
    right: 0rem;
    top: 0;
    color: #000;
`;
